<template>
  <div class="home" :class="{ 'test-env': isTestEnv }">
    <el-container class="home-container">
      <!-- 侧边栏 -->
      <el-aside :width="isCollapse ? '64px' : '265px'" v-if="!hideAside">
        <div class="totle">
          <img src="@/assets/imgs/logo.png" alt />
          <span>{{ username }}</span>
        </div>
        <div class="toggle-button" @click="toggleCollapse">|||</div>
        <!-- 侧边栏菜单区 -->
        <el-menu :background-color="menuBgColor" :text-color="menuTextColor" :active-text-color="menuActiveTextColor" unique-opened
          :collapse="isCollapse" :collapse-transition="false" router :default-active="activePath">
          <!-- 一级菜单 -->
          <el-submenu :index="item.authId + ''" v-for="item in auths" :key="item.authId">
            <!-- 一级菜单模板区 -->
            <template slot="title">
              <!-- 图标 -->
              <i :class="item.icon"></i>
              <!-- 文本 -->
              <span>{{ item.authName }}</span>
            </template>

            <!-- 二级菜单 -->
            <el-menu-item :index="'/' + subItem.component" v-for="subItem in item.sonAuths" :key="subItem.authId"
              @click="saveNavState('/' + subItem.component, subItem.authName)">
              <!-- 图标 -->
              <i class="el-icon-menu"></i>
              <span>{{ subItem.authName }}</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <!-- 头部主题区 -->
        <el-main>
          <div class="main" v-if="!hideAside">
            <el-tabs v-model="pageCurrent" type="card" closable style="width:90%" @tab-click="tabChange"
              @tab-remove="removeTab">
              <el-tab-pane v-for="item in pageList" :key="item.name" :name="item.name">
                <span slot="label">
                  <span>{{ item.label }}</span>
                  <span class="refresh">
                    <i style="font-size:15px;" @click="refreshModule" class="el-icon-refresh"></i>
                  </span>
                </span>
              </el-tab-pane>
            </el-tabs>
            <div class="ss" style="width:10%">
              <el-button type="info" size="mini" class="mini" style="height:40px" @click="logout">退出</el-button>
            </div>
          </div>
          <!-- 右侧主题区 -->

          <!-- 路由占位符 -->
          <transition name="fade" mode="out-in">
            <keep-alive :exclude="exclude">
              <router-view v-if="condition" ref="view" />
            </keep-alive>
          </transition>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getFaceValueList } from '@/utils/normalApi.js'
import { type } from '@/store/index'


export default {
  data() {
    return {
      activePath: '',
      // 是否折叠
      isCollapse: false,
      pageCurrent: '',
      pageList: [],
      pageList_: [],
      exclude: null,
      env: type == 1 ? 'test' : 'production',
      condition: true,
      hideAside: false
    }
  },
  computed: {
    ...mapState(['username', 'auths', 'channels']),
    isTestEnv() {
      return type === 1
    },
    menuBgColor() {
      return this.isTestEnv ? '#fff' : '#333744'
    },
    menuTextColor() {
      return this.isTestEnv ? '#000' : '#fff'
    },
    menuActiveTextColor() {
      return this.isTestEnv ? '#fff' : '#409Eff'
    }
  },
  async created() {
    try {
      // 内嵌app参数处理
      const isRunningInApps = this.isRunningInApp();
      if (isRunningInApps) {
        var metaInfo = WebCallBack.getMateInfo();
        if (metaInfo && typeof metaInfo === 'string') {
          try {
            var metaInfoObj = JSON.parse(metaInfo);
            // 将hideAside、username、token存入sessionStorage，且传入store
            if (metaInfoObj.hideAside) {
              this.hideAside = metaInfoObj.hideAside == 1
            }
            if (metaInfoObj.token) {
              this.$store.state.token = metaInfoObj.token
              sessionStorage.setItem('token', metaInfoObj.token)
            }
            if (metaInfoObj.username) {
              this.$store.state.username = metaInfoObj.username
              sessionStorage.setItem('username', metaInfoObj.username)
            }
          } catch (e) {
            console.warn('Meta info parsing failed:', e);
          }
        }
      }

      this.activePath = window.$cookies.get('activePath_kissu')

      try {
        const pageListStr = window.$cookies.get('pageList_kissu');
        if (pageListStr) {
          this.pageList_ = JSON.parse(pageListStr)
          this.pageList = this.distinct3(this.pageList_)
        }
      } catch (e) {
        console.warn('Page list parsing failed:', e);
        this.pageList_ = []
        this.pageList = []
      }

      try {
        const authsStr = window.$cookies.get('auths_kissu');
        if (authsStr) {
          let auths = JSON.parse(authsStr)
          this.$store.state.auths = auths
        }
      } catch (e) {
        console.warn('Auths parsing failed:', e);
        this.$store.state.auths = []
      }

      try {
        const channelsStr = window.$cookies.get('channels_kissu');
        if (channelsStr) {
          let channels = JSON.parse(channelsStr)
          this.$store.state.channels = channels
        }
      } catch (e) {
        console.warn('Channels parsing failed:', e);
        this.$store.state.channels = []
      }

      if (window.$cookies.get('username_kissu')) {
        let username = window.$cookies.get('username_kissu')
        this.$store.state.username = username
      }

      // 颜值标签列表
      this.$store.state.faceValueList = await getFaceValueList()
    } catch (e) {
      console.error('Created hook error:', e);
    }
  },

  watch: {
    $route: {
      handler(to, form) {
        //当路由改变时，检测该路由是否已经在打开的页面之中，如果不在，就添加进去
        if (form == null) {
          this.pageCurrent = to.path
        }
      },
      immediate: true
    }
  },
  methods: {
    isRunningInApp() {
      // 获取当前浏览器的 User-Agent
      var userAgent = navigator.userAgent;
      // 判断 User-Agent 中是否包含特定标识符
      return userAgent.indexOf('quhongniubiManager') != -1;
    },
    async logout() {
      if (this.env == 'test') {
        this.clearCookies()
        const { data: res } = await this.$axios({
          type: 'GET',
          url: this.$store.getters.path.login_out,
          withCredentials: true,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token
          }
        })
        if (res.code != 0) return this.$message(res.msg)
      } else {
        const { data: res } = await this.$axios({
          type: 'GET',
          url: this.$store.getters.path.login_out,
          withCredentials: true,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token
          }
        })
        if (res.code != 0) return this.$message(res.msg)
        this.clearCookies()
      }
    },
    clearCookies() {
      window.sessionStorage.clear()
      this.$cookies.remove('activePath_kissu')
      this.$cookies.remove('pageList_kissu')
      this.$cookies.remove('username_kissu')
      this.$cookies.remove('userLevel_kissu')
      this.$cookies.remove('token_kissu')
      this.$cookies.remove('auths_kissu')
      this.$cookies.remove('channels_kissu')
      localStorage.clear()
      this.$router.push('/login')
    },
    distinct3(arr) {
      for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i].name === arr[j].name) {
            arr.splice(j, 1)
            j = j - 1
          }
        }
      }
      return arr
    },
    // 保存连接的激活状态
    saveNavState(activePath, name) {
      this.$cookies.set('activePath_kissu', activePath)
      this.activePath = activePath
      this.pageList_.push({ name: activePath, label: name })
      this.pageList = this.distinct3(this.pageList_)
      if (this.pageList.length == 0) {
        this.pageList.push({ name: activePath, label: name })
      }
      this.$cookies.set('pageList_kissu', JSON.stringify(this.pageList))
      this.pageCurrent = activePath
    },
    // 点击按钮实现菜单折叠展开
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    handleTabsEdit(targetName, action) {
      if (action === 'remove') {
        let tabs = this.editableTabs
        let activeName = this.editableTabsValue
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1]
              if (nextTab) {
                activeName = nextTab.name
              }
            }
          })
        }

        this.editableTabsValue = activeName
        this.editableTabs = tabs.filter(tab => tab.name !== targetName)
      }
    },
    keepAliveUrl() {
      let result = this.name.map(item => {
        return item.activePath
      })
      return result.join(',')
    },
    refreshModule() {
      this.exclude = this.$refs.view.$options.name
      this.condition = !this.condition
      this.$nextTick(() => {
        this.exclude = null
        this.condition = !this.condition
      })
    },
    tabChange(tab) {
      let a = window.location.hash.split('#')
      if (a[1] == tab.name) return
      // let url = this.$route.query.split()
      this.$router.push({ path: tab.name }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
      this.$cookies.set('activePath_kissu', tab.name)
      this.activePath = tab.name
    },
    removeTab(targetName) {
      let tabs = this.pageList
      let activeName = this.pageCurrent
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
      }
      this.pageCurrent = activeName
      this.pageList = tabs.filter(tab => tab.name !== targetName)
      this.$cookies.set('pageList_kissu', JSON.stringify(this.pageList))
      this.pageList_ = this.pageList
      this.$router.push({ path: activeName }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
}

.home-container {
  height: 100%;
}

.el-header {
  display: flex;
  flex-direction: row-reverse;
  background-color: #373d41;
  color: #fff;
  font-size: 20px;
  padding: 10px 20px;
}

.el-select {
  width: 100px;
  margin-right: 15px;
}

.totle {
  width: 100%;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  color: #fff;

  img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
}

.el-aside {
  background-color: #333744;

  .el-menu {
    border-right: none;
  }
}

/* 测试服颜色区分 */
.test-env {
  .el-aside {
    background-color: #fff;
  }

  .totle {
    color: #000;
  }

  .toggle-button {
    background-color: #f5f5f5;
    color: #000;
  }

  .el-main {
    background-color: #f1f6fc;
  }

  /* 选中菜单项的背景色 */
  .el-menu-item.is-active {
    background-color: #7985fb !important;
    color: #fff !important;
  }

  .el-menu-item.is-active i {
    color: #fff !important;
  }

  .el-submenu__title:hover {
    background-color: #f5f5f5 !important;
  }

  .el-menu-item:hover {
    background-color: #f5f5f5 !important;
  }
}

.el-main {
  background-color: #eaedf1;
  padding: 0;
}

.iconfont {
  margin-right: 13px;
}

.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/*fade*/
.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all 0.5s;
}

.breadcrumb-enter,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

.breadcrumb-move {
  transition: all 0.5s;
}

.breadcrumb-leave-active {
  position: absolute;
}

.main {
  display: flex;

  >.ss {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
